import React, { Component } from "react";
 
class Profile extends Component {
  render() {
    return (
      <div>
        <h2>Coming Soon!</h2>
        <p>.....................</p>
      </div>
    );
  }
}
 
export default Profile;



// WEBPACK FOOTER //
// ./src/Profile.js